import { render, staticRenderFns } from "./lbt.vue?vue&type=template&id=51112fff&scoped=true"
import script from "./lbt.vue?vue&type=script&lang=js"
export * from "./lbt.vue?vue&type=script&lang=js"
import style0 from "./lbt.vue?vue&type=style&index=0&id=51112fff&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51112fff",
  null
  
)

export default component.exports